import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Box } from '../../../../../../../../../../CommonComponents/OPL/Box/Box';

export const GradientMask = styled(Box)({
  '&:after, &:before': {
    content: "''",
    position: 'absolute',
    top: 0,
    width: '200px',
    height: '100%',
    zIndex: 1,
  },

  '&:after': {
    right: 0,
    background: 'linear-gradient(270deg, rgba(255,255,255,1) 0%,  rgba(255,255,255,0) 100%)',
  },

  '&:before': {
    left: 0,
    background: 'linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)',
  },
});

export const GroupContent = styled(motion.section)({
  display: 'flex',
  overflow: 'hidden',
  marginBottom: '-8px',
  paddingBottom: '8px',
});
